<template>
  <div class="component-navigation" :class="{fixed: fixed}" :style="{background: backgroundColor, color: fontColor}">
    <div class="back-wrap" @click="goBack()">
      <md-icon class="icon-back" name="arrow-left" size="lg"></md-icon>
    </div>
    <span class="title">{{ title }}</span>
    <span class="option-text" :style="optionStyle" v-if="optionText" @click="handleClickOption">{{ optionText }}</span>
  </div>
</template>

<script>
import { Icon } from 'mand-mobile'
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
export default {
  name: 'navigation',
  components: {
    [Icon.name]: Icon,
  },
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isListenClick: {
      type: Boolean,
      default: false,
    },
    isKeepAlive: {
      type: Boolean,
      default: false,
    },
    optionText: {
      type: String,
      default: '',
    },
    optionStyle: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '#fff',
    },
    fontColor: {
      type: String,
      default: '#1f2f3d',
    },
  },
  methods: {
    /**
     * 返回
     */
    goBack() {
      if (this.isListenClick) {
        this.$emit('listenClick')
      } else {
        const routerStack = LocalStore.get(Consts.STORE_ROUTE_STACK)
        if (routerStack && routerStack.length > 1) {
          if (routerStack[1].name !== 'login') {
            this.$router.go(-1)
          } else {
            this.$router.push({ name: 'home' })
          }
        } else {
          this.$router.push({ name: 'home' })
        }
      }
    },
    /**
     * 点击操作
     */
    handleClickOption() {
      this.$emit('option')
    },
  },
}
</script>

<style lang="scss" scoped>
.component-navigation {
  position: relative;
  height: 0.88rem;
  line-height: 0.88rem;
  background: #fff;
  color: #1f2f3d;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255, 0.1);
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .back-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 0.88rem;
    height: 0.88rem;
    text-align: center;
    .icon-back {
      height: 0.36rem;
      vertical-align: middle;
    }
  }
  .title {
    font-size: 0.3rem;
    font-family: PingFangSC-Regular;
    font-weight: bold;
  }
  .option-text {
    position: absolute;
    right: 0;
    top: 0;
    padding: 0 0.3rem;
    display: inline-block;
    height: 0.88rem;
    line-height: 0.88rem;
    &:active {
      opacity: 0.3;
    }
  }
}
</style>
